// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".breadcrumb-item[data-v-674aa5f6]{color:var(--pult-muted);cursor:default;cursor:pointer}.breadcrumb-item .divider[data-v-674aa5f6]{color:var(--pult-muted);margin:0 8px 0 4px}.breadcrumb_link[data-v-674aa5f6]:hover{color:var(--pult-accent)}", ""]);
// Exports
module.exports = exports;
